<template >
  <div>
    <div class="row">
      <div class="col-12">
        <!-- <div class="row mt-5">
          <div class="form-group">
            <div class="form-label-group ml-4">
              <input
                type="text"
                id="inputSearch"
                class="form-control"
                placeholder="ძებნა"
                v-model="searchText"
                v-on:keyup.enter="searchData()"
              />
              <label for="inputSearch">ძებნა</label>
            </div>
          </div>
          <i
            class="fa fa-search searchBtn ml-3 mt-1"
            title="ძებნა"
            @click="searchData()"
          ></i>
        </div>-->
      </div>
    </div>
    <!--Edit form-->
    <div
      class="modal fade bd-example-modal-lg"
      id="editApplication"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              {{ modalHeader }}
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <section class="container py-4">
              <div class="row">
                <div class="col-md-12">
                  <ul id="tabsJustified" class="nav nav-tabs">
                    <li class="nav-item">
                      <a
                        data-target="#product"
                        data-toggle="tab"
                        class="nav-link small text-uppercase modal-nav active pointer"
                        >მთავარი</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        data-target="#gallery"
                        data-toggle="tab"
                        class="nav-link small text-uppercase modal-nav pointer"
                        >ფაილები</a
                      >
                    </li>
                  </ul>
                  <br />
                  <div id="tabsJustifiedContent" class="tab-content">
                    <div
                      id="product"
                      class="tab-pane fade"
                      v-bind:class="{ active: true, show: true }"
                    >
                      <div class="row">
                        <!-- აქ მიდის პირველი ტაბი -->
                        <form class="col-12 col-md-6">
                          <div class="form-group">
                            <div class="form-label-group">
                              <input
                                type="text"
                                id="inputFirstName"
                                class="form-control"
                                placeholder="სახელი"
                                autofocus="autofocus"
                                v-model="application.firstName"
                                v-on:input="$v.application.$touch"
                                v-bind:class="{
                                  'error-border':
                                    $v.application.firstName.$error,
                                  valid:
                                    $v.application.firstName.$dirty &&
                                    !$v.application.firstName.$invalid,
                                }"
                              />
                              <label for="inputFirstName">სახელი</label>
                            </div>
                            <div class="form-label-group mt-3">
                              <input
                                type="text"
                                id="inputLastName"
                                class="form-control"
                                placeholder="გვარი"
                                autofocus="autofocus"
                                v-model="application.lastName"
                                v-on:input="$v.application.$touch"
                                v-bind:class="{
                                  'error-border':
                                    $v.application.lastName.$error,
                                  valid:
                                    $v.application.lastName.$dirty &&
                                    !$v.application.lastName.$invalid,
                                }"
                              />
                              <label for="inputLastName">გვარი</label>
                            </div>
                            <div class="form-label-group mt-3">
                              <input
                                type="text"
                                id="inputMobile"
                                class="form-control"
                                placeholder="ტელეფონი"
                                autofocus="autofocus"
                                v-model="application.mobile"
                                v-on:input="$v.application.$touch"
                                v-bind:class="{
                                  'error-border': $v.application.mobile.$error,
                                  valid:
                                    $v.application.mobile.$dirty &&
                                    !$v.application.mobile.$invalid,
                                }"
                              />
                              <label for="inputMobile">ტელეფონი</label>
                            </div>
                            <div class="form-label-group mt-3">
                              <input
                                type="text"
                                id="inputEmail"
                                class="form-control"
                                placeholder="მეილი"
                                autofocus="autofocus"
                                v-model="application.email"
                                v-on:input="$v.application.$touch"
                                v-bind:class="{
                                  'error-border': $v.application.email.$error,
                                  valid:
                                    $v.application.email.$dirty &&
                                    !$v.application.email.$invalid,
                                }"
                              />
                              <label for="inputEmail">მეილი</label>
                            </div>
                            <div class="form-label-group mt-3">
                              <input
                                type="text"
                                id="inputPersonalId"
                                class="form-control"
                                placeholder="პირადი ნომერი"
                                autofocus="autofocus"
                                readonly="true"
                                v-model="application.personalId"
                                v-on:input="$v.application.$touch"
                                v-bind:class="{
                                  'error-border':
                                    $v.application.personalId.$error,
                                  valid:
                                    $v.application.personalId.$dirty &&
                                    !$v.application.personalId.$invalid,
                                }"
                              />
                              <label for="inputPersonalId">პირადი ნომერი</label>
                            </div>
                            <div class="form-label-group mt-3">
                              <input
                                type="text"
                                id="inputBirthDate"
                                class="form-control"
                                placeholder="დაბადების თარიღი"
                                autofocus="autofocus"
                                v-model="application.birthDate"
                                v-on:input="$v.application.$touch"
                                v-bind:class="{
                                  'error-border':
                                    $v.application.birthDate.$error,
                                  valid:
                                    $v.application.birthDate.$dirty &&
                                    !$v.application.birthDate.$invalid,
                                }"
                              />
                              <label for="inputBirthDate"
                                >დაბადების თარიღი</label
                              >
                            </div>
                            <div class="form-label-group mt-3">
                              <div class="dropdown mt-3">
                                <label>სქესი</label>
                                <button
                                  class="btn dropdown-toggle"
                                  type="button"
                                  id="dropdownGenderSelect"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  {{ genderText }}
                                </button>
                                <div
                                  class="dropdown-menu scrollable"
                                  aria-labelledby="dropdownGenderSelect"
                                >
                                  <a
                                    class="dropdown-item pointer"
                                    v-for="genderValue in genderArray"
                                    :key="genderValue.id"
                                    v-on:focus="$v.application.$touch"
                                    @click="
                                      dropDownGenderClick(
                                        genderValue.name,
                                        genderValue.id
                                      )
                                    "
                                    v-bind:class="{
                                      'error-border':
                                        $v.application.genderId.$error,
                                      valid:
                                        $v.application.genderId.$dirty &&
                                        !$v.application.genderId.$invalid,
                                    }"
                                    >{{ genderValue.name }}</a
                                  >
                                </div>
                              </div>
                            </div>
                            <div class="form-label-group mt-3">
                              <input
                                type="text"
                                id="inputDocumentNumber"
                                class="form-control"
                                placeholder="დოკუმენტის ნომერი"
                                autofocus="autofocus"
                                v-model="application.documentNumber"
                                v-on:input="$v.application.$touch"
                                v-bind:class="{
                                  'error-border':
                                    $v.application.documentNumber.$error,
                                  valid:
                                    $v.application.documentNumber.$dirty &&
                                    !$v.application.documentNumber.$invalid,
                                }"
                              />
                              <label for="inputDocumentNumber"
                                >დოკუმენტის ნომერი</label
                              >
                            </div>
                          </div>
                        </form>
                        <form class="col-12 col-md-6">
                          <div class="form-label-group mt-3">
                            <div class="dropdown mt-3">
                              <label>მოქალაქეობა</label>
                              <button
                                class="btn dropdown-toggle"
                                type="button"
                                id="dropdownGenderSelect"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                {{ countryText }}
                              </button>
                              <div
                                class="dropdown-menu scrollable"
                                aria-labelledby="dropdownGenderSelect"
                              >
                                <a
                                  class="dropdown-item pointer"
                                  v-for="countryValue in countryArray"
                                  :key="countryValue.id"
                                  v-on:focus="$v.application.$touch"
                                  @click="
                                    dropDownCountryClick(
                                      countryValue.name,
                                      countryValue.id
                                    )
                                  "
                                  v-bind:class="{
                                    'error-border':
                                      $v.application.citizenshipCountryId
                                        .$error,
                                    valid:
                                      $v.application.citizenshipCountryId
                                        .$dirty &&
                                      !$v.application.citizenshipCountryId
                                        .$invalid,
                                  }"
                                  >{{ countryValue.name }}</a
                                >
                              </div>
                            </div>
                          </div>
                          <div class="form-label-group mt-3">
                            <input
                              type="text"
                              id="inputBirthPlace"
                              class="form-control"
                              placeholder="დაბადების ადგილი"
                              autofocus="autofocus"
                              v-model="application.birthPlace"
                              v-on:input="$v.application.$touch"
                              v-bind:class="{
                                'error-border':
                                  $v.application.birthPlace.$error,
                                valid:
                                  $v.application.birthPlace.$dirty &&
                                  !$v.application.birthPlace.$invalid,
                              }"
                            />
                            <label for="inputBirthPlace"
                              >დაბადების ადგილი</label
                            >
                          </div>
                          <div class="form-label-group mt-3">
                            <input
                              type="text"
                              id="inputActualAddress"
                              class="form-control"
                              placeholder="ფაქტიური მისამართი"
                              autofocus="autofocus"
                              v-model="application.actualAddress"
                              v-on:input="$v.application.$touch"
                              v-bind:class="{
                                'error-border':
                                  $v.application.actualAddress.$error,
                                valid:
                                  $v.application.actualAddress.$dirty &&
                                  !$v.application.actualAddress.$invalid,
                              }"
                            />
                            <label for="inputActualAddress"
                              >ფაქტიური მისამართი</label
                            >
                          </div>
                          <div class="form-label-group mt-3">
                            <input
                              type="text"
                              id="inputRegistrationAddress"
                              class="form-control"
                              placeholder="რეგისტრაციის მისასმართი"
                              autofocus="autofocus"
                              v-model="application.registrationAddress"
                              v-on:input="$v.application.$touch"
                              v-bind:class="{
                                'error-border':
                                  $v.application.registrationAddress.$error,
                                valid:
                                  $v.application.registrationAddress.$dirty &&
                                  !$v.application.registrationAddress.$invalid,
                              }"
                            />
                            <label for="inputRegistrationAddress"
                              >რეგისტრაციის მისასმართი</label
                            >
                          </div>
                          <div class="form-group mt-3">
                            <div class="form-group form-check mt-3">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="hasMerchantAdd"
                                v-on:input="$v.application.$touch"
                                v-model="application.isVerified"
                              />
                              <label
                                class="form-check-label"
                                for="hasMerchantAdd"
                                >ვერიფიცირებულია</label
                              >
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div id="gallery" class="tab-pane fade">
                      <!-- აქ მიდის მეორე ტაბი -->

                      <div v-if="isEdit">
                        <div v-if="application.documents.length > 0">
                          <div
                            class="row"
                            v-for="file in application.documents"
                            :key="file.id"
                          >
                            <div class="col-6 mt-3 ml-3">
                              <img
                                width="80px"
                                class="img-thumbnail"
                                :src="imageUrl1(file.imageSrc)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div v-if="application.documents.length > 0">
                          <div
                            v-for="(image, key) in application.documents"
                            :key="image.name"
                          >
                            <div class="row">
                              <div class="col-6 mt-3">
                                <img
                                  width="80px"
                                  class="img-thumbnail"
                                  v-bind:ref="'image' + parseInt(key)"
                                  v-bind:src="imagePreviews[parseInt(key)]"
                                  name="asd111"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              გაუქმება
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--Grid-->
    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <th class="numeric">სახელი</th>
            <th class="numeric">გვარი</th>
            <th class="numeric">მობილურის ნომერი</th>
            <th class="numeric">პირადი ნომერი</th>
            <th class="numeric">სტატუსი</th>
            <th class="numeric">ნახვა</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="heading"
            v-for="value in filteredDataArray"
            :key="value.id"
          >
            <td data-title="სახელი" class="numeric">
              {{ value.firstName }}
            </td>
            <td data-title="გვარი" class="numeric">
              {{ value.lastName }}
            </td>
            <td data-title="მობილურის ნომერი" class="numeric">
              {{ value.mobile }}
            </td>
            <td data-title="პირადი ნომერი" class="numeric">
              {{ value.personalId }}
            </td>
            <td data-title="სტატუსი" class="numeric">
              {{ value.statusId == 3 ? "დაუარებული" : "დადასტურებული" }}
            </td>

            <td data-title="ნახვა" class="numeric">
              <div>
                <i
                  class="fa fa-pencil-alt fa-fw editBtn"
                  title="ნახვა"
                  data-toggle="modal"
                  data-target="#editApplication"
                  @click="clearData(), editApplicationModal(value)"
                ></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import { required, email } from "vuelidate/lib/validators";
import { imageURL } from "../../settings/settings.js";

export default {
  name: "newApplication",
  data() {
    return {
      dataArray: [],
      filteredDataArray: [],
      genderArray: [],
      countryArray: [],
      application: {
        accountId: null,
        firstName: null,
        lastName: null,
        mobile: null,
        email: null,
        personalId: null,
        birthDate: null,
        genderId: null,
        citizenshipCountryId: null,
        documentNumber: null,
        actualAddress: null,
        registrationAddress: null,
        birthPlace: null,
        isVerified: null,
        smsCode: null,
        comment: null,
        documents: [],
      },
      genderText: null,
      countryText: null,
      modalHeader: "განაცხადის ნახვა",
      fileInputKey: 0,
      isEdit: true,
      editGalleryArray: [],
    };
  },
  validations: {
    application: {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      mobile: {
        required,
      },
      email: {
        required,
      },
      personalId: {
        required,
      },
      birthDate: {
        required,
      },
      genderId: {
        required,
      },
      documentNumber: {
        required,
      },
      actualAddress: {
        required,
      },
      registrationAddress: {
        required,
      },
      birthPlace: {
        required,
      },
      isVerified: {
        required,
      },
      citizenshipCountryId: {
        required,
      },
    },
  },
  async created() {
    let usersResult = await this.$http.getFinishedApplications();
    this.dataArray = usersResult.data.res;
    this.filteredDataArray = this.dataArray;

    this.genderArray = [
      { id: 1, name: "მამრობითი" },
      { id: 2, name: "მდედრობითი" },
    ];

    this.countryArray = [
      { id: 1, name: "საქართველო" },
      { id: 2, name: "იაპონია" },
      { id: 3, name: "კენია" },
    ];
  },
  methods: {
    getGenderName(id) {
      let index = this.genderArray.findIndex((d) => d.id === id);
      if (index !== -1) {
        return this.genderArray[index].name;
      }
    },
    getCountryName(id) {
      let index = this.countryArray.findIndex((d) => d.id === id);
      if (index !== -1) {
        return this.countryArray[index].name;
      }
    },
    editApplicationModal(value) {
      this.application = Object.assign({}, value);

      this.application.accountId = value.accountId;
      this.application.firstName = value.firstName;
      this.application.lastName = value.lastName;
      this.application.mobile = value.mobile;
      this.application.email = value.email;
      this.application.personalId = value.personalId;
      this.application.birthDate = value.birthDate;
      this.application.genderId = value.genderId;
      this.genderText = this.getGenderName(value.genderId);
      this.application.documentNumber = value.documentNumber;
      this.application.actualAddress = value.actualAddress;
      this.application.registrationAddress = value.registrationAddress;

      this.application.birthPlace = value.birthPlace;
      this.application.isVerified = value.isVerified;
      this.application.comment = value.comment;
      this.application.citizenshipCountryId = value.citizenshipCountryId;
      this.countryText = this.getCountryName(value.citizenshipCountryId);
      this.isVerified = value.isVerified;

      this.modalHeader = "განაცხადის ნახვა";

      console.log(value);
    },
    searchData() {
      //ბექშია გადასატანი
      this.filteredDataArray = this.dataArray.filter(
        (item) =>
          item.firstName.toLowerCase().indexOf(this.searchText.toLowerCase()) >
            -1 ||
          item.lastName.toLowerCase().indexOf(this.searchText.toLowerCase()) >
            -1 ||
          item.mobile.toLowerCase().indexOf(this.searchText.toLowerCase()) >
            -1 ||
          item.personalId.toLowerCase().indexOf(this.searchText.toLowerCase()) >
            -1
      );
    },
    dropDownGenderClick(desc, id) {
      console.log(desc, id);
      this.application.genderId = id;
      this.genderText = this.getGenderName(id);
    },
    dropDownCountryClick(desc, id) {
      console.log(desc, id);
      this.application.citizenshipCountryId = id;
      this.countryText = this.getCountryName(id);
    },

    imageUrl1(mainImageUpuloadName) {
      if (mainImageUpuloadName !== "Choose FIle ...") {
        return imageURL + mainImageUpuloadName;
      }
    },
    clearData() {
      this.application.id = null;
      this.application.firstName = null;
      this.application.lastName = null;
      this.application.mobile = null;
      this.application.email = null;
      this.application.personalId = null;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";

.error-border {
  border-color: #ffb3b3;
  box-shadow: none;
}
.editBtn {
  margin-left: 10px;
  font-size: 30px;
  cursor: pointer;
  color: #52af8e;
}
.deleteBtn {
  font-size: 30px;
  cursor: pointer;
  color: #d43f3a;
  margin-left: 10px;
}

.searchBtn {
  font-size: 40px;
  margin-top: -5px;
  cursor: pointer;
  color: #489d7f;
}

.addNewBtn {
  font-size: 44px;
  margin-left: 15px;
  cursor: pointer;
  color: #52af8e;
  margin-top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/FinishedApplication.vue